// Two-line period cell for the SOW table. Top row: `D MMM YYYY → D MMM YYYY`.
// Bottom row: tone-aware proximity meta-line driven by `formatSowPeriod`.
//
// Mirrors the shape of the InsuranceTab CoveragePeriodCell so the two
// register surfaces read with the same vocabulary.

import { formatSowPeriod, type SowPeriodTone } from "./sowPeriodFormat";
import type { SowStatus } from "../../../../types";

interface SowDateCellProps {
  startDate: string;
  endDate: string;
  status: SowStatus;
}

const TONE_CLASS: Record<SowPeriodTone, string> = {
  muted: "text-slate-400 dark:text-slate-500",
  neutral: "text-slate-700 dark:text-slate-200",
  success: "text-emerald-600 dark:text-emerald-400",
  brand: "text-brand-600 dark:text-brand-400",
  danger: "text-red-600 dark:text-red-400 font-medium",
};

export default function SowDateCell({
  startDate,
  endDate,
  status,
}: SowDateCellProps) {
  const { range, meta, tone } = formatSowPeriod({
    startDate,
    endDate,
    status,
  });

  return (
    <div className="flex flex-col">
      <span className="text-body text-slate-900 dark:text-slate-100">
        {range}
      </span>
      <span className={`text-caption ${TONE_CLASS[tone]}`}>{meta}</span>
    </div>
  );
}
